.root {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 480px;
  padding: 16px 20px 8px;
}

.empty {
  color: var(--color-text-muted);
  font-size: 13px;
  padding: 16px 0;
  text-align: center;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.row {
  align-items: center;
  background: var(--color-surface-subtle);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  display: flex;
  gap: 12px;
  padding: 8px 12px;
}

.row-is-primary {
  border-color: var(--color-primary);
}

.name {
  flex-grow: 1;
  font-size: 14px;
  font-weight: 500;
}

.flag {
  align-items: center;
  display: flex;
  font-size: 12px;
  gap: 6px;
}

.controls {
  display: flex;
  gap: 4px;
}

.adder {
  border: 1px solid var(--color-border);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
}

.adder-row {
  align-items: center;
  display: flex;
  gap: 8px;
}

.adder-search {
  flex-grow: 1;
}

.suggestions {
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style: none;
  margin: 0;
  max-height: 160px;
  overflow-y: auto;
  padding: 0;
}

.suggestion-item {
  align-items: stretch;
  display: flex;
}

.suggestion-empty {
  color: var(--color-text-muted);
  font-size: 12px;
  padding: 4px 0;
}
